export const enListScopeFilter = {
	trigger: "Select Lists",
	triggerCount_one: "{{count}} list",
	triggerCount_other: "{{count}} lists",
	list: "list",
	lists: "lists",
	selectedSuffix: "selected",
	noListsSelected: "No lists selected",
	unsaved: "unsaved",
	selectAll: "Select all",
	clear: "Clear",
	cancel: "Cancel",
	apply: "Apply",
	applyCount_one: "Apply ({{count}} list)",
	applyCount_other: "Apply ({{count}} lists)",
	archived: "Archived ({{count}})",
	archivedTag: "Archived",
	searchPlaceholder: "Search lists...",
	noResults: "No lists found",
	irrelevant: {
		inbox: {
			section: "No replies yet ({{count}})",
			hint: "A lead only shows up in the Inbox once it replies — until then it stays in the Outbox.",
			crossLink: "Open in Outbox",
			emptyTitle: "None of your lists have replies yet",
			emptyForList: "No replies in “{{list}}” yet",
		},
		outbox: {
			section: "Nothing sent yet ({{count}})",
			hint: "A lead leaves the Outbox as soon as it replies — look for those in the Inbox.",
			crossLink: "Open in Inbox",
			emptyTitle: "None of your lists have outgoing messages yet",
		},
		readyToSend: {
			section: "No drafts ({{count}})",
			hint: "These lists have no messages waiting for review — their leads were already sent or have answered.",
			emptyTitle: "None of your lists have drafts waiting",
		},
	},
};
